import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface WidgetSkeletonProps {
  borderRadius?: string;
  background?: string;
}

const WidgetSkeleton: React.FC<WidgetSkeletonProps> = ({
  borderRadius = "0.5rem",
  background = "#f5f5f5",
}) => {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: background,
        zIndex: 20,
        borderRadius: borderRadius,
        overflow: "hidden",
      }}
    >
      <Skeleton height="200%" width="100%" style={{ display: "block" }} />
    </div>
  );
};

export default WidgetSkeleton;
